/*
 * Gestión del tema claro/oscuro de la landing (dark | light | auto).
 * - Persiste la elección en localStorage('payslip-theme').
 * - Aplica data-theme al <html> SOLO mientras una página de landing está
 *   montada (initTheme/teardownTheme), para no alterar los controles nativos
 *   ni el color-scheme del resto de la app (/app usa su propio tema).
 */

const STORAGE_KEY = 'payslip-theme';
const VALID = ['light', 'dark', 'auto'];

export function getStoredTheme() {
  try {
    const v = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
    return VALID.includes(v) ? v : 'auto';
  } catch {
    return 'auto';
  }
}

export function applyTheme(mode) {
  const m = VALID.includes(mode) ? mode : 'auto';
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', m);
  }
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, m);
  } catch {
    /* almacenamiento no disponible — el tema vive sólo en memoria */
  }
  return m;
}

/** Aplica el tema guardado al montar la landing. Devuelve el modo aplicado. */
export function initTheme() {
  const m = getStoredTheme();
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', m);
  }
  return m;
}

/** Quita data-theme al desmontar la landing (deja /app intacto). */
export function teardownTheme() {
  if (typeof document !== 'undefined') {
    document.documentElement.removeAttribute('data-theme');
  }
}
